/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs */

const en_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside cover is left blank for the physical binding gutter.`)
};

const es_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraportada interior se deja en blanco para el margen de encuadernación física.`)
};

const fr_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La page intérieure de la couverture est laissée vierge pour la reliure physique.`)
};

const de_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Innenseite des Covers bleibt für die physische Bindung leer.`)
};

const ja_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理的な製本スペースのため、表紙の裏は空白のままになります。`)
};

const zh_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内封面留白，以便于实体装订。`)
};

const ar_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم ترك الغلاف الداخلي فارغًا لمساحة التجليد المادي.`)
};

const id_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul dalam dibiarkan kosong untuk ruang penjilidan fisik.`)
};

const it_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'interno della copertina viene lasciato vuoto per la rilegatura fisica.`)
};

const ru_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренняя сторона обложки остается пустой для физического переплета.`)
};

const pt_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O interior da capa é deixado em branco para a margem de encadernação física.`)
};

const ko_inside_cover_is_left_blank_for_the_physical_bindin = /** @type {(inputs: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`물리적 제본 공간을 위해 표지 내부는 비워둡니다.`)
};

/**
* | output |
* | --- |
* | "Inside cover is left blank for the physical binding gutter." |
*
* @param {Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inside_cover_is_left_blank_for_the_physical_bindin = /** @type {((inputs?: Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inside_Cover_Is_Left_Blank_For_The_Physical_BindinInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "es") return es_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "fr") return fr_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "de") return de_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "ja") return ja_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "zh") return zh_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "ar") return ar_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "id") return id_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "it") return it_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "ru") return ru_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	if (locale === "pt") return pt_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
	return ko_inside_cover_is_left_blank_for_the_physical_bindin(inputs)
});